
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20.317","height":"25.807"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 308","fill":"none","stroke":"#464646","stroke-miterlimit":"10","stroke-width":"1.8"}},[_c('path',{attrs:{"data-name":"Rectangle 184","d":"M2.665 5.883h14.988v13a6.028 6.028 0 01-6.028 6.023H8.693a6.028 6.028 0 01-6.028-6.023v-13h0z"}}),_c('path',{attrs:{"data-name":"Path 550","d":"M19.417 4.407a1.48 1.48 0 01-1.476 1.476H2.375a1.476 1.476 0 110-2.951H17.94a1.474 1.474 0 011.477 1.475z"}}),_c('path',{attrs:{"data-name":"Path 551","d":"M13.499 2.376a1.489 1.489 0 01-.106.555H6.928a1.48 1.48 0 01-.107-.555A1.481 1.481 0 018.297.9h3.723a1.478 1.478 0 011.479 1.476z"}}),_c('g',{attrs:{"data-name":"Group 290","stroke-linecap":"round"}},[_c('path',{attrs:{"data-name":"Line 35","d":"M13.798 8.982v11.889"}}),_c('path',{attrs:{"data-name":"Line 36","d":"M10.159 8.982v11.889"}}),_c('path',{attrs:{"data-name":"Line 37","d":"M6.52 8.982v11.889"}})])])])
          )
        }
      }
    